import { useState } from "react";
import { auth } from "../../../firebase/config";
import { sendPasswordResetEmail } from "firebase/auth";
import { useNavigate, Link } from "react-router-dom";
import Header from "../../../components/common/Header/Header";

import "./ForgotPassword.css";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [emailEnviado, setEmailEnviado] = useState(false);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      await sendPasswordResetEmail(auth, email);
      setEmailEnviado(true);
    } catch (err) {
      if (err.code === "auth/user-not-found") {
        setError("Este e-mail não consta em nossa base de dados.");
      } else {
        setError("Ocorreu um erro. Tente novamente em instantes.");
      }
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-screen">
      <Header />
      <div className="forgot-password-container">
        
        {!emailEnviado ? (
          <>
            <header className="forgot-header">
              <span>REPIQUE</span>
              <h1>Recuperar Senha</h1>
              <p>Insira seu e-mail abaixo para receber as instruções de redefinição.</p>
              <div className="divider"></div>
            </header>

            <form onSubmit={handleResetPassword} className="forgot-form">
              {error && <p className="error-message">{error}</p>}
              
              <div className="input-group">
                <label htmlFor="email">E-MAIL CADASTRADO</label>
                <input 
                  id="email"
                  type="email" 
                  placeholder="exemplo@email.com" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required 
                />
              </div>

              <button type="submit" className="btn-forgot" disabled={loading}>
                {loading ? "Processando..." : "Enviar Instruções"}
              </button>
            </form>
          </>
        ) : (
          <div className="success-message-area">
            <div className="success-icon">✓</div>
            <h2>E-mail enviado!</h2>
            <p>
              Tchê, enviamos um link de redefinição para <strong>{email}</strong>.
            </p>
            <div className="instructions-box">
              <p>• Verifique sua caixa de entrada e a pasta de <strong>Spam</strong>.</p>
              <p>• O link expira em breve por questões de segurança.</p>
            </div>
            <p className="footer-note">Já redefiniu sua senha ou encontrou o acesso?</p>
            <Link to="/login" className="btn-back-login">Voltar para o Login</Link>
          </div>
        )}

        <footer className="forgot-footer">
          <Link to="/login">← Voltar</Link>
        </footer>
      </div>
    </div>
  );
}